<nb-card [size]="'medium'" [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="large">
  <nb-card-header>
    <nb-checkbox [checked]="selectAll" (checkedChange)="toggleAll($event)">Import mission from template :</nb-checkbox>
  </nb-card-header>
  <nb-card-body>
    <nb-list>
      <nb-list-item *ngFor="let mission of missions; let i = index">
        <nb-checkbox [checked]="checkedMissions[mission.id]" (checkedChange)="toggle($event, mission.id)"> {{ mission.name | txtTranslate }}</nb-checkbox>
        
      </nb-list-item>
    </nb-list>
  </nb-card-body>
  <nb-card-footer>
      <button class="cancel mr-3" nbButton status="danger" (click)="cancel()">Cancel</button>
      <button nbButton status="success" (click)="importMissionSelected()">Import</button>
  </nb-card-footer>
</nb-card>